export default "__VITE_ASSET__BY3fHWdR__"